export const citizensAreaCVSearchTabPathName = 'cv-search';
